import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import {
  legacy_createStore as createStore,
  applyMiddleware,
  compose,
} from "redux";
import { thunk } from "redux-thunk";
import { Amplify } from "aws-amplify";
import App from "./components/App";
import reducers from "./redux/reducers";
import awsconfig from "./aws-exports";
import { BrowserRouter } from "react-router-dom";
import { LicenseInfo } from "@mui/x-license";
import "./index.css";
import "@aws-amplify/ui-react/styles.css";

LicenseInfo.setLicenseKey(process.env.REACT_APP_DATAGRID_LICENSE_KEY);

// Configure Amplify with v6 syntax
Amplify.configure(awsconfig);

// Redux DevTools setup
const composeEnhancers =
  (typeof window !== "undefined" &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
  compose;

// Create Redux store
export const store = createStore(
  reducers,
  composeEnhancers(applyMiddleware(thunk))
);

// Get root element and render app
const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

root.render(
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>
);
